/* import __COLOCATED_TEMPLATE__ from './account-details-modal.hbs'; */
var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { feature } from '@square/ember-features/macros';
import { formatNumber } from '@banking/ui/utils/checking/utils';
import BankingToastComponent from '@banking/ui/components/banking/toast';
const ROUTING_NUMBER_INDICES = [6, 3];
const ACCOUNT_NUMBER_INDICES = [9, 6, 3];
let AccountDetailsModal = (_dec = feature('deposits/enable_direct_deposit_account_limit'), _class = class AccountDetailsModal extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "flash", _descriptor2, this);
    _initializerDefineProperty(this, "canViewDirectDepositLimit", _descriptor3, this);
    _initializerDefineProperty(this, "directDepositAccount", _descriptor4, this);
    _initializerDefineProperty(this, "directDepositLimit", _descriptor5, this);
  }
  get accountNumber() {
    return formatNumber(this.args.directDepositAccount.accountNumber, ACCOUNT_NUMBER_INDICES);
  }
  get routingNumber() {
    return formatNumber(this.args.directDepositAccount.routingNumber, ROUTING_NUMBER_INDICES);
  }
  showCopyFailedToast() {
    this.flash.globalWarning(this.intl.t('banking.components.accountDetailsCard.copyFailed'), {
      flashComponent: BankingToastComponent,
      dismiss: this.dismiss,
      componentOptions: {
        dismissLabel: this.intl.t('banking.shared.toast.dismiss')
      }
    });
  }
  showCopySuccessToast(key) {
    this.flash.globalSuccess(this.intl.t(key), {
      flashComponent: BankingToastComponent,
      dismiss: this.dismiss,
      componentOptions: {
        dismissLabel: this.intl.t('banking.shared.toast.dismiss')
      }
    });
  }
  async copyAccountNumber() {
    const clipboard = window.navigator?.clipboard;
    if (!clipboard?.writeText || !this.accountNumber) {
      this.showCopyFailedToast();
      return;
    }
    try {
      await clipboard.writeText(this.accountNumber.replace(/\s/g, ''));
      this.showCopySuccessToast('banking.components.accountDetailsCard.accountNumber.copied');
    } catch {
      this.showCopyFailedToast();
    }
  }
  async copyRoutingNumber() {
    const clipboard = window.navigator?.clipboard;
    if (!clipboard?.writeText || !this.routingNumber) {
      this.showCopyFailedToast();
      return;
    }
    try {
      await clipboard.writeText(this.routingNumber.replace(/\s/g, ''));
      this.showCopySuccessToast('banking.components.accountDetailsCard.routingNumber.copied');
    } catch {
      this.showCopyFailedToast();
    }
  }
  dismiss() {
    return this.flash.clearGlobalMessage();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "flash", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "canViewDirectDepositLimit", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "directDepositAccount", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.args.directDepositAccount;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "directDepositLimit", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.args.directDepositLimit;
  }
}), _applyDecoratedDescriptor(_class.prototype, "copyAccountNumber", [action], Object.getOwnPropertyDescriptor(_class.prototype, "copyAccountNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "copyRoutingNumber", [action], Object.getOwnPropertyDescriptor(_class.prototype, "copyRoutingNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dismiss", [action], Object.getOwnPropertyDescriptor(_class.prototype, "dismiss"), _class.prototype), _class);
export { AccountDetailsModal as default };